import { useEffect, useState } from 'react';

import { useAuth } from '../context/AuthContext';
import { subscribeIncomingRequestCount } from '../services/friendsService';

/**
 * How many people are waiting on YOU to accept.
 *
 * Lives in the nav, not in the Friends screen, on purpose. The count only does
 * its job if you can see it from somewhere you already are — a badge that is
 * only visible once you have navigated to the screen it is telling you to visit
 * is not a notification, it is a decoration, and that was the state of this
 * feature: requests arrived correctly and nobody ever learned they had one.
 *
 * Real count or nothing. Zero renders no badge.
 */
export function usePendingFriendRequests(): number {
  const { currentUser } = useAuth();
  const [count, setCount] = useState(0);
  const uid = currentUser?.uid || '';

  useEffect(() => {
    if (!uid) {
      setCount(0);
      return;
    }
    const unsub = subscribeIncomingRequestCount(uid, setCount);
    return () => {
      try { unsub(); } catch { /* already torn down */ }
    };
  }, [uid]);

  return count;
}
